import React from 'react';
import { useTranslation } from '../i18n';
const DEMO_URL = 'https://calendar.app.google/kAzzsMuwfngdzNZf9';
export function Hero() {
  const {
    t
  } = useTranslation();
  return <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20 bg-black" data-id="element-84">
      <div className="absolute inset-0 overflow-hidden pointer-events-none" data-id="element-85">
        <div className="absolute w-[60vw] h-[60vw] max-w-[800px] max-h-[800px] rounded-full opacity-[0.28]" style={{
        background: 'radial-gradient(circle, #FF6B00 0%, #FF3CAC 50%, transparent 70%)',
        filter: 'blur(100px)',
        animation: 'heroBlob1 15s ease-in-out infinite',
        top: '-10%',
        left: '-15%'
      }} data-id="element-86" />
        <div className="absolute w-[70vw] h-[70vw] max-w-[900px] max-h-[900px] rounded-full opacity-[0.25]" style={{
        background: 'radial-gradient(circle, #7B2FFF 0%, #2563EB 40%, #00E5FF 70%, transparent 85%)',
        filter: 'blur(120px)',
        animation: 'heroBlob2 12s ease-in-out infinite',
        bottom: '-20%',
        right: '-15%'
      }} data-id="element-87" />
        <div className="absolute w-[50vw] h-[50vw] max-w-[700px] max-h-[700px] rounded-full opacity-[0.22]" style={{
        background: 'radial-gradient(circle, #C850C0 0%, #4158D0 40%, #80D0C7 70%, transparent 85%)',
        filter: 'blur(110px)',
        animation: 'heroBlob3 18s ease-in-out infinite',
        top: '30%',
        left: '35%'
      }} data-id="element-88" />
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center" data-id="element-89">
        <h1 className="text-5xl md:text-7xl lg:text-[80px] font-bold tracking-tight leading-[1.1] mb-6 text-white" data-id="element-90">
          {t('hero.title')}
        </h1>

        <p className="text-xl md:text-2xl text-white/60 max-w-2xl mx-auto mb-12 font-light" data-id="element-91">
          {t('hero.subtitle')}
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-92">
          <a href={DEMO_URL} target="_blank" rel="noopener noreferrer" className="bg-gradient-animated rounded-full px-8 py-4 text-base font-semibold text-white w-full sm:w-auto hover:scale-105 transition-transform duration-300 shadow-[0_0_30px_rgba(255,60,172,0.3)] text-center" data-id="element-93">
            {t('hero.bookDemo')}
          </a>

          <a href="#products" className="rounded-full border border-white/20 px-8 py-4 text-base font-semibold text-white w-full sm:w-auto hover:border-transparent hover:bg-white/5 transition-all duration-300 relative group overflow-hidden text-center" data-id="element-94">
            <div className="absolute inset-0 bg-gradient-animated opacity-0 group-hover:opacity-100 transition-opacity duration-300" style={{
            padding: '1px',
            WebkitMask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
            WebkitMaskComposite: 'xor',
            maskComposite: 'exclude'
          }} data-id="element-95"></div>
            <span className="relative z-10" data-id="element-96">{t('hero.exploreProducts')}</span>
          </a>
        </div>
      </div>
    </section>;
}